// Copyright © 2017-2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/views/Index.vue'
import DocsApi from '@/views/docs/Api.vue'
import GettingStarted from '@/views/docs/GettingStarted.vue'
import Login from '@/views/Login.vue'
import PasswordResetConfirm from 'vue-common/components/PasswordResetConfirm'
import PasswordResetForm from 'vue-common/components/PasswordResetForm'
import PasswordResetRequest from 'vue-common/components/PasswordResetRequest'
import Pricing from '@/views/Pricing'
import PrivacyPolicy from '@/views/PrivacyPolicy'
import RegisterAgreement from '@/views/RegisterAgreement'
import RegisterForm from '@/views/RegisterForm'
import TermsOfService from '@/views/TermsOfService'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      redirect: '/login',
      children: [
        {
          path: 'api',
          component: DocsApi,
          name: 'docsApi'
        },
        {
          path: 'manual',
          component: GettingStarted,
          name: 'docsManual'
        },
        {
          path: 'legal/privacypolicy',
          component: PrivacyPolicy,
          name: 'privacyPolicy'
        },
        {
          path: 'legal/termsofservice',
          component: TermsOfService,
          name: 'termsOfService'
        },
        {
          path: 'login',
          component: Login,
          name: 'login'
        },
        {
          path: '/passwordreset/form',
          component: PasswordResetForm,
          name: 'passwordResetForm'
        },
        {
          path: '/passwordreset/request',
          component: PasswordResetRequest,
          name: 'passwordResetRequest'
        },
        {
          path: 'passwordreset/confirm',
          component: PasswordResetConfirm,
          name: 'passwordResetConfirm'
        },
        {
          path: 'pricing',
          component: Pricing,
          name: 'pricing'
        },
        {
          path: 'get-started',
          component: RegisterAgreement,
          name: 'registerAgreement'
        },
        {
          path: 'register',
          component: RegisterForm,
          name: 'registerForm'
        },
        // catch all redirect
        {
          path: '*',
          redirect: '/login'
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js